<template>
  <!--遮罩层开始-->
  <div class="confirm-mask-wrap" onselectstart="return false">
    <transition name="fade">
      <div class="confirm-mask" v-show="show">
        <div class="confirm-mask-content" ref="confirmMaskContent">
          <p class="desc">
            <slot name="desc">提示层</slot>
          </p>
          <div class="btn-wrap">
            <a class="btn cancel" href="javascript: void(0)" @click="colseMask">取消</a>
            <a class="btn revoke" href="javascript: void(0)">撤销审核</a>
          </div>
        </div>
      </div>
    </transition>
  </div>
  <!--遮罩层结束-->
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'confirmMask',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    beforeUpdate () {
      this.$nextTick(() => {
        // 初始化遮罩层的位置
        this.init()
      })
    },
    methods: {
      init () {
        // 获取弹出层内容
        let oConfirmMaskContent = this.$refs.confirmMaskContent
        // 计算左边边距
        let left = oConfirmMaskContent.offsetWidth / 2
        // 计算上边边距
        let top = oConfirmMaskContent.offsetHeight / 2
        // 对边距进行赋值
        oConfirmMaskContent.style.marginLeft = `${-left}px`
        oConfirmMaskContent.style.marginTop = `${-top}px`
      },
      colseMask () {
        this.$emit('closeMaskEv', !this.show)
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "confirmMask.styl";
</style>



// WEBPACK FOOTER //
// src/components/confirmMask/confirmMask.vue